

































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import ResponsiveImage from '@/common/vue/ResponsiveImage.vue';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';

const Co2Labeling = () => import('@/webcomponents/co2-labeling/Co2Labeling.vue');

const StageItemProps = Vue.extend({
  props: {
    mainHeadline: String,
    subHeadline: String,
    textColor: String,
    labelingColor: String,
    pictureJson: String,
    desktopVideo: String,
    tabletVideo: String,
    mobileVideo: String,
    linkText: String,
    externalLink: String,
    internalLink: String,
    linkTarget: String,
    labelingJson: String,
    editMode: Boolean,
  },
});

@Component({
  components: {
    ResponsiveImage,
    Co2Labeling,
  },
})
export default class StageItem extends mixins(StageItemProps, ChildComponentMixin, ResizeUpdateMixin) {
  $refs!: {
    video: HTMLVideoElement;
    labeling: HTMLElement;
  };

  index = 0;
  status: string | null = null;
  labelingActive = false;
  videoProgress: string | null = '0';
  labelingHeight = 0;
  labelingOverflowHeight = 0;

  created () {
    this.initChildComponentMixin('StageItem');
    this.updateLabelingHeight();
    this.$on('resizeEnd', this.updateLabelingHeight);
  }

  updated () {
    this.updateLabelingHeight();
  }

  updateLabelingHeight () {
    const labelingElem = this.$refs.labeling;
    if (labelingElem) {
      this.labelingHeight = Math.ceil(labelingElem.getBoundingClientRect().height);
      if (this.isMobile || this.isTabletPortrait) {
        // explained: a computed style of bottom = -115px means that the element is overflowing its
        // container by 115px.
        // a computed style of bottom = +15px means, that the element is not overflowing.
        const bottomStyle = getComputedStyle(labelingElem).bottom;
        const bottomValue = parseInt(
          bottomStyle.replace('px', ''),
          10,
        );
        this.labelingOverflowHeight = Math.max(
          (bottomValue * -1),
          0,
        );
      } else {
        this.labelingOverflowHeight = 0;
      }
    } else {
      this.labelingHeight = 0;
      this.labelingOverflowHeight = 0;
    }
  }

  @Watch('status')
  updateLabelingStatus () {
    requestAnimationFrame(() => {
      // set labeling active after a frame was rendered, to always show initial animation
      this.labelingActive = this.status === 'active' || this.status === 'prev-back-in';
    });
  }

  get rootClass () {
    return {
      'brandhub-stage-item--edit-mode': this.editMode,
      'brandhub-stage-item--first': this.index === 0,
      'brandhub-stage-item--last': this.index === 1,
      'brandhub-stage-item--active': this.status === 'active', // set in parent on registration
      'brandhub-stage-item--active-out': this.status === 'active-out',
      'brandhub-stage-item--active-back-out': this.status === 'active-back-out',
      'brandhub-stage-item--prev-back-in': this.status === 'prev-back-in',
      'brandhub-stage-item--primary': this.labelingColor === 'primary',
    };
  }

  get rootStyle () {
    return {
      '--labeling-height': `${this.labelingHeight}px`,
    };
  }

  get labelingClass () {
    return {
      'brandhub-stage-item__labeling--primary': this.labelingColor === 'primary',
      'brandhub-stage-item__labeling--active': this.labelingActive,
    };
  }

  get videoSource () {
    if (this.isResizeUpdateMixinInitialized) {
      if (this.mobileVideo && this.isMobile) {
        return this.mobileVideo;
      }
      if (this.tabletVideo && this.isTablet) {
        return this.tabletVideo;
      }
      if (this.desktopVideo) {
        return this.desktopVideo;
      }
    }
    return '';
  }

  handleTimeUpdate () {
    this.videoProgress = this.videoTimePercent();
  }

  videoTimePercent () {
    if (this.$refs.video && this.$refs.video.currentTime !== 0) {
      return ((this.$refs.video.currentTime / this.$refs.video.duration) * 100).toFixed(2);
    }
    return null;
  }
}
